import React from 'react';
import styled from 'styled-components';
var MatchTextWrapper = styled.span.withConfig({
  displayName: "MatchTextWidth__MatchTextWrapper",
  componentId: "sc-308qdi-0"
})(["display:inline-grid;align-items:center;& > span{grid-area:1 / 1;}& > [aria-hidden='true']{visibility:hidden;}"]);
/**
 * Toggle between main and alternative content without changing how much space is used.
 * The component will always take up as much space as the longest content.
 *
 * Useful for toggling button labels without changing the size of the button.
 */

function MatchTextWidth(_ref) {
  var children = _ref.children,
    alternativeText = _ref.alternativeText,
    showAlternativeText = _ref.showAlternativeText;
  return /*#__PURE__*/React.createElement(MatchTextWrapper, null, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": showAlternativeText
  }, children), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": !showAlternativeText
  }, alternativeText));
}
export default MatchTextWidth;